module.exports = __webpack_public_path__ + "static/media/medicalMarpractice.4b37b24a.svg";